import { styled } from '@fluentui/utilities';
import { ToggleBase } from './Toggle.base';
import { getStyles } from './Toggle.styles';
export var Toggle = styled(ToggleBase, getStyles, undefined, {
    scope: 'Toggle',
});
//# sourceMappingURL=Toggle.js.map